import React from "react";
import ReactDOM from "react-dom/client";
//import App from "./components/app/app.jsx";
import "./index.css";
import App from "./app";
import CustomCursor from "./components/customCursor";





const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CustomCursor/>
    <App/>
  </React.StrictMode>
);